import { Scale } from 'lucide-preact';
import { StackedBarChart } from '../../components/charts';
import { ChartCard, LoadingState } from '../../components/ui';
import type { StackedBarData } from '../../components/charts/StackedBarChart';

interface UnitMapBalanceSectionProps {
  unitCurrency: string;
  balanceSheetData: { xLabels: string[]; stacks: StackedBarData[] };
  balanceSheetLoading: boolean;
}

export function UnitMapBalanceSection({
  unitCurrency,
  balanceSheetData,
  balanceSheetLoading,
}: UnitMapBalanceSectionProps) {
  return (
    <ChartCard
      title="Balance Sheet Overview"
      icon={<Scale size={16} strokeWidth={2} />}
      className="unit-balance-card"
    >
      {balanceSheetLoading ? (
        <LoadingState message="Loading balance sheet…" />
      ) : (
        <StackedBarChart
          className="unit-balance-chart"
          xLabels={balanceSheetData.xLabels}
          stacks={balanceSheetData.stacks}
          title=""
          xAxisLabel=""
          yAxisLabel={unitCurrency}
          currencyCode={unitCurrency}
          tooltipPrefix="Year "
          height="100%"
        />
      )}
    </ChartCard>
  );
}
